import React from "react";
import { LegalPage } from "../components/LegalPage";
import { datenschutz } from "../data/legal";
export function Datenschutz() {
  return <LegalPage title="Datenschutzerklärung" intro="Informationen darüber, wie wir mit Ihren personenbezogenen Daten umgehen." sections={datenschutz} data-id="element-290" data-mp="ui1utrw884vn" />;
}